// extracted by mini-css-extract-plugin
module.exports = {"display":"RaceResults_display__UG1Ce","entry":"RaceResults_entry__21IM2","btnDivs":"RaceResults_btnDivs__1navZ","btn":"RaceResults_btn__UL7y4"};